export const projectsCards = [
  {
    url: "https://sentrys.io/",
    name: "Sentrys",
    img: "https://sentrys.io/img/sentrys-logo-sm.68e2d45f.png"
  },
  {
    url: "https://play.google.com/store/apps/details?id=com.sentrys.transit",
    name: "Tortuga - Google Play Console",
    img: "https://play-lh.googleusercontent.com/NY3CeKXCb3PYw_42ME0hjs7c0_u6W5-wNFvysKP0ygH4iCEvq_rCL1Ix6RLRIiNimDTk5LUl3lggFwAF74al=w240-h480-rw"
  },
  {
    url: "https://sostaxi-admin.netlify.app/",
    name: "SOS Taxi - Admin Panel",
    img: "https://play-lh.googleusercontent.com/U6aY1D7q3U2OLyjAVXJS997e2dwmuGNlaT05S61NxylqVIXU4g-gNDSeO4HOwr1Qeg=w240-h480-rw"
  },
  {
    url: "https://safeguardbg-admin.netlify.app/",
    name: "Safeguard - Admin Panel",
    img: "https://play-lh.googleusercontent.com/zAWTHhDJyoAI8K4X1OppGRkqDOEnfLnIAlU5oQEn-HUODuvKankHPGAG1sKYCkehYgc=w240-h480-rw"
  },
    {
    url: "https://vdahnovenie-bg.com/",
    name: "Vdahnovenie - Wordpress",
    img: "https://vdahnovenie-bg.com/wp-content/uploads/2025/09/logo.png"
  },
];